import { Component, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LoadingService } from "./shared/services/loading/loading.service";
import { CommonModule } from "@angular/common";
import { AuthenticationService } from "./shared/services/authentication/authentication.service";
import { ExportService } from "./shared/services/export/export.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, RouterOutlet, MatProgressSpinnerModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit {
  title = "USS Toolbox";

  constructor(public loadingService: LoadingService,
    private authenticationService: AuthenticationService,
    private exportService: ExportService
  ) {}

  async ngOnInit() {
    try {
      console.log("Initializing USS Toolbox application...");
      await this.authenticationService.initializeAuth();
      console.log("Authentication initialization completed");
    } catch (error) {
      console.error("Failed to initialize authentication:", error);
    }
    // Check for existing export jobs on app startup (handles page refresh scenarios)
    this.exportService.checkForExistingJobs().subscribe();
  }
}
